import { RouteObject } from 'react-router';

import { AuthRoot } from '@/shared/app/auth/auth-root';
import { FullscreenLoader } from '@/shared/components/ui/fullscreen-loader/fullscreen-loader';
import { getReseller } from '@/shared/utils/reseller/reseller';

const sdaOnboardingRoutes: RouteObject = {
  path: '/onboarding',
  hydrateFallbackElement: <FullscreenLoader />,
  element: <AuthRoot />,
  children: [
    {
      index: true,
      lazy: async () => {
        const { OnboardingRootRoute } = await import('./onboarding-root');
        return { Component: OnboardingRootRoute };
      },
    },
    {
      path: 'confirmation',
      lazy: async () => {
        const { OnboardingConfirmationRoute } =
          await import('./onboarding-confirmation');
        return { Component: OnboardingConfirmationRoute };
      },
    },
  ],
};

export const onboardingRoutes: RouteObject =
  getReseller() === 'sda' ? sdaOnboardingRoutes : {};
